import config from '../config'
import { authHeader } from './auth-header'

export const employeeService = {
  getAllEmployees,
  updateEmployee,
  createEmployee,
  deleteEmployee
}

function getAllEmployees () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/users/getemployees`, requestOptions).then(handleResponse)
}

function updateEmployee (employeeData) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(employeeData)
  }
  return fetch(`${config.apiUrl}/users/update`, requestOptions).then(handleResponse)
}

function createEmployee (employeeData) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(employeeData)
  }
  return fetch(`${config.apiUrl}/users/create`, requestOptions).then(handleResponse)
}

function deleteEmployee (id) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ id })
  }
  return fetch(`${config.apiUrl}/users/delete`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = (data && data.Response) || (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data.Response
  })
}
